import React, { useState, useContext, useEffect }  from 'react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../stores/root_store';
import useAuth from 'hooks/useAuth';
import { Role, RoleProps } from '../stores/role_store';

type RolesContextType = {
    roles: Role[],
    rolesNames: string[],
    rolesLoaded: boolean,
    hasRole: (role: string) => boolean,
    setRoles: (roles: Role[]) => void,
    sudoGrant: (user: string, role: string) => Promise<RoleProps[]>
    sudoRevoke: (user: string, role: string) => Promise<RoleProps[]>
    sudoList: (user: string) => Promise<RoleProps[]>
}

const RolesContext = React.createContext<RolesContextType>({
    roles: [] as Role[],
    rolesNames: [] as string[],
    rolesLoaded: false,
    hasRole: () => false,
    setRoles: () => { throw "Not implemented" },
    sudoGrant: () => { throw "Not implemented" },
    sudoRevoke: () => { throw "Not implemented" },
    sudoList: () => { throw "Not implemented" },
});


const RolesProvider = observer(({ children }: { children: React.ReactNode  })=> {

    const [roles, setRoles] = useState([] as Role[]);
    const [rolesLoaded, setRolesLoaded] = useState(false);
    const { roleStore } = useContext(RootStoreContext);
    const { currentUser }  = useAuth();

    useEffect(() => {
        if(!currentUser?.uuid) {
            console.log("no user, no roles");
            return;
        }
        roleStore.fetchAllRoles().
            then(() => {
                const r = roleStore.getUserRoles(currentUser.uuid)
                setRoles(r);
            })
            .finally(() => setRolesLoaded(true));

    }, [roleStore, setRoles, currentUser.uuid]);

    const getRolesNames = () => {
        return roles.map(r => r.role);
    }


    const data = {
        roles: roles,
        rolesNames: getRolesNames(),
        rolesLoaded: rolesLoaded,
        hasRole: (role: string) => roles.some(r => r.role === role),
        setRoles: setRoles,
        sudoGrant: roleStore.sudoGrant,
        sudoRevoke: roleStore.sudoRevoke,
        sudoList: roleStore.sudoList,
    }
    return (
        <RolesContext.Provider value={data}>{ children }</RolesContext.Provider>
    )

});

export { RolesContext, RolesProvider };
